import { useLocation } from "react-router-dom";

const Base = ({ openMobileMenu, children }) => {
  const location = useLocation();
  const routes = [
    "/seller-overview",
    "/seller-inventory",
    "/seller-sales",
    "/seller-wallet",
    "/seller-profile",
  ].includes(location.pathname);
  return (
    <div
      className={`${
        routes ? "flex" : "block"
      } w-full min-h-screen font-Lato 2xl:w-1500px 2xl:m-auto relative scrollbar-thin ${
        openMobileMenu ? "overflow-hidden" : "overflow-auto"
      }`}
    >
      {children}
    </div>
  );
};
export default Base;
